// extracted by css-extract-rspack-plugin
export default {"separator":"FGw1P0","timeup":"CIqVdC"};